<template>
  <div class="template">
    <q-form class="q-px-xl" ref="loginForm" @submit.prevent.stop="onSubmit">
      <div class="group-input col-12 row q-mt-sm">
        <label for="os_number">Login</label>
        <q-input
          id="os_number"
          ref="osNumberRef"
          type="text"
          class="col-12 q-mt-sm"
          bg-color="white"
          maxlength="30"
          color="red-9"
          dense
          outlined
          unmasked-value
          v-model="auth.username"
          :rules="[(val) => !!val.length || 'Campo Obrigatório', isValidEmail]"
          lazy-rules
        />
      </div>
      <div class="group-input col-12 row q-mt-sm">
        <label for="os_number">Senha</label>
        <q-input
          id="os_number"
          ref="osNumberRef"
          :type="isPwd ? 'password' : 'text'"
          class="col-12 q-mt-sm"
          bg-color="white"
          maxlength="12"
          color="red-9"
          dense
          outlined
          unmasked-value
          v-model="auth.password"
          :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
          lazy-rules
        >
          <template v-slot:append>
            <q-icon
              size="18px"
              :name="isPwd ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              @click="isPwd = !isPwd"
            />
          </template>
        </q-input>
      </div>

      <div class="submit-btn col-12 row q-mt-sm">
        <div class="submit-btn col-md-12 flex justify-end section-btn">
          <q-btn
            class="submit-btn"
            unelevated
            no-caps
            :loading="btnLoading"
            size="md"
            type="submit"
            label="Entrar"
            rounded
            color="red-9"
          />
        </div>
      </div>
      <div class="footer row flex justify-center q-mt-md">
        <router-link to="sigin-user">
          Primeiro acesso?
          <span>Cadastre-se</span>
        </router-link>
        <router-link class="q-ml-md" to="reset-password">
          esqueceu a
          <span>senha</span>
          ?
        </router-link>
      </div>
    </q-form>
  </div>
</template>

<script>
//-----VUEJS
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

//------UTILS
import technicianData from "@/constats.js";
import { isUserTechnician } from "@/utils/auth/verifyUserLogged.js";
import getStatusContingecy from "@/utils/contingency/getStatusContingecy.js";

//-----QUASAR
import { useQuasar } from "quasar";

//-----SERVICES
import ContingencyServices from "@/services/ContingencyServices";

export default {
  name: "Login",

  setup() {
    //----CONSTANTS
    const loginForm = ref(null);
    const emailPattern =
      /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
    const $q = useQuasar();
    const router = useRouter();
    const store = useStore();

    //----VARIABLES
    let auth = ref({
      username: "",
      password: "",
    });
    let btnLoading = ref(false);
    let isPwd = ref(true);
    let contingencyServices = new ContingencyServices();

    function isValidEmail(val) {
      if (auth.value.username.indexOf("@") < 0) {
        return true;
      }
      return emailPattern.test(val) || "Email inválido";
    }

    async function onSubmit() {
      if (!(await loginForm.value.validate())) {
        $q.notify({
          color: "red-5",
          message: "Você precisa preencher todos os campos obrigatórios",
        });
        return;
      }
      btnLoading.value = true;

      let data = {
        username: auth.value.username,
        password: auth.value.password,
      };

      await contingencyServices
        .authenticate(data)
        .then(async (response) => {
          await getUserToken(response);
        })
        .catch((error) => {
          btnLoading.value = false;
          $q.notify({
            message: error.toString(),
            color: "red-9",
            position: "top",
          });
        });
    }

    async function getUserToken(userLoggedInfo) {
      await contingencyServices
        .userGenetateToken(technicianData())
        .then(async (response) => {
          localStorage.setItem("vega@token", response.token);
          store.commit("setUserData", userLoggedInfo);
          btnLoading.value = false;

          if (isUserTechnician()) {
              router.push({ name: "config-history" });
          } else {
            var isActive = await getStatusContingecy();
            
            if (isActive) {
            router.push( "/service-history");
            } 
            else {
              localStorage.removeItem("vega@token");
              localStorage.clear();
              router.push({ name: "disabled" });
            }
          }
        })
        .catch((error) => {
          btnLoading.value = false;
          $q.notify({
            message: error.toString(),
            color: "red-9",
            position: "top",
          });
        });
    }

    return {
      //----VARIABLES
      loginForm,
      auth,
      btnLoading,
      isPwd,

      //FUNCTIONS
      isValidEmail,
      onSubmit,
    };
  },
};
</script>
<style lang="scss" scoped>
.template {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #e5e5e5;

  label {
    color: rgba(0, 0, 0, 0.4);
    font-size: 0.875rem;
    font-family: Roboto;
    font-weight: 700;
  }
}

.submit-btn {
  width: 100%;
  display: flex;
}

.footer {
  a {
    font-size: 0.75rem;
    color: #868686;
    text-decoration: none;

    span {
      color: #c62828;
    }
  }
}
</style>
